// Auto generated file, do not manually modify!
// com.hotpads.satellite.web.api.web.renter.v1.SatelliteWebRenterWarningsHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { SatelliteWebRenterUserWarningsResponseDto } from '../..';

export const SatelliteWebRenterWarningsHandler_getUserWarnings_Path = '/api/web/renter/v1/getUserWarnings';

/**
 * Get user warnings for personal contact details and external links
 */
export const SatelliteWebRenterWarningsHandler_getUserWarnings = (client = getClient()) => {
  return httpFrontEndRequest<never, never, SatelliteWebRenterUserWarningsResponseDto>(
    {
      endpoint: SatelliteWebRenterWarningsHandler_getUserWarnings_Path,
      method: 'GET',
      contextPath: '/satellite',
    },
    client,
  );
};
